import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const AudioBox = styled(Box, {})({
  display: 'none',

  [theme.breakpoints.up('laptop')]: {
    display: 'block',
  },
});
